'use strict';

angular.module('teams').factory('AppstoreIntegration', ['$resource',
	function($resource) {
		return $resource('v1/app-stores/:mobileAppId', {
			mobileAppId: '@mobileAppId'
		}, {
			importData: {
				url: 'v1/app-stores/:mobileAppId/import-data',
				method: 'POST',
				isArray: false,
				cache : false
			},
			exportData: {
				url: 'v1/app-stores/:mobileAppId/export-data',
				method: 'POST',
				isArray: false,
				cache : false
			},
			connect: {
				method: 'POST',
				isArray: false,
				cache : false
			},
			disconnect: {
				method: 'DELETE',
				isArray: false,
				cache : false
			}
		});
	}
]);
